
export default (state, action) => {
    if (typeof state == 'undefined') {
        state = [];
    }
    switch (action.type) {
        case 'GET_LICENSE_REQUEST_INITIATED':
            return {isFetching: true};
        case 'GET_LICENSE_REQUEST_SUCCESS':
            return {isFetching: false, data: action.payload};
        case 'GET_LICENSE_REQUEST_ERROR':
            return {isFetching: false, data: action.payload};
        default:
            return state;
    }
};